import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/fubon/assets/styles/components/detail-center/index.scss'
import rankIconRed from '@/companys/fubon/assets/images/icons/marketdetail_indicator_icon_red.png'
import rankIconOrange from '@/companys/fubon/assets/images/icons/marketdetail_indicator_icon_orange.png'
import rankIconYellow from '@/companys/fubon/assets/images/icons/marketdetail_indicator_icon_yellow.png'
import rankIconLightblue from '@/companys/fubon/assets/images/icons/marketdetail_indicator_icon_light_blue.png'
import rankIconBlue from '@/companys/fubon/assets/images/icons/marketdetail_indicator_icon_blue.png'

import Dropdown from '@/components/Dropdown/Dropdown';
import LoadingLayer from '@/components/Spinner/LoadingLayer'; 

import {  Converter,keyDownFunctions,accessibilityFunctions  } from '@/helpers/functions';
import { ACTION_TYPE } from "@/constants/w-socket";
import { stockActions } from "@/actions/trading/stock.action";

class Index extends Component {
    constructor(props){
        super(props)
        this.state = {
            marketID:'',
            InstrumentID: '',
            rankName : [
                {className:"market_excellent",color:'#b91b29',icon:rankIconRed},
                {className:"market_good",color:'#e8882d',icon:rankIconOrange},
                {className:"market_neutral",color:'#e7cf29',icon:rankIconYellow},
                {className:"market_commonly",color:'#5ebaec',icon:rankIconLightblue},
                {className:"market_poor",color:'#328ec0',icon:rankIconBlue},
            ],
            ul_check_data:['market_main_indicator','market_comprehensive_profit','market_comprehensive_growth'],
            ul_check_index:0,
            main_select_data:['market_basic_earnings_per_share','market_pen','market_p_e','market_quote_pb'],
            profit_select_data:['market_gross_margin','market_net_amount_interest_rate','market_retrun_on_equity','market_retrun_of_assets'],
            growth_select_data:['market_income_growth_rate','market_profit_growth_rate','market_assets_growth_rate'],
            mapData:['market_basic_earnings_per_share','market_pen','market_p_e','market_quote_pb'], 
            block_select_index:0,
            dropdownData:[],
            currentDropdownOption:null,
            resReport:[],
            resName:null,  
            rankData:null,
            // rankData:[["HK","1111","288.14669"],["HK","6190","24.02216"],["HK","1983","21.69492"],["HK","1216","19.62967"],["HK","3698","14.97052"],["HK","3866","14.25465"],["HK","1551","13.23047"],["HK","3618","12.22137"],["HK","1916","10.55083"],["HK","416","10.29745"],["HK","998","10.18278"],["HK","3968","10.03223"],["HK","1398","9.84283"],["HK","3988","9.71231"],["HK","2139","9.45749"],["HK","1288","9.37145"],["HK","6138","9.00323"],["HK","6818","8.49217"],["HK","6196","8.15072"],["HK","11","7.95180"],["HK","1658","7.94552"],["HK","2066","7.88253"],["HK","2388","7.71307"],["HK","2356","7.15440"],["HK","939","6.91934"],["HK","440","6.88913"],["HK","2016","6.43912"],["HK","3328","6.04868"],["HK","23","6.04039"],["HK","626","5.98390"],["HK","1963","5.97344"],["HK","5","5.52135"],["HK","1988","4.61159"],["HK","6122","2.76397"],["HK","2888","2.53715"],["HK","1578","2.43853"]],
            rowName:'',
            load:true,
            iconRank:'',
            rating:'',
            rankDataMax:'',
            PercentageFlag:false
        }
    }
    render() {
        const {language} = this.props
        const { rankName,
                ul_check_data,
                ul_check_index,
                mapData,block_select_index,
                dropdownData,
                rankData,
                load,
                resName,
                rating,
                iconRank,
                rankDataMax,
                PercentageFlag} = this.state

        return (
            <div className='index-body' >
                <div className='index'>
                {/* headSelect */}
                <LoadingLayer load={load} />
                <div className='ul_check'>
                    <div className='select'>
                        <ul>
                        { ul_check_data.map((item,index)=>{
                         return <li key={item} 
                                    onClick={() => this.hanldeHeaderList(item,index)} 
                                    onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.hanldeHeaderList(item,index))}
                                    {...accessibilityFunctions.hasTabIndex()}
                                    className={ul_check_index === index ? 'borderActive' : 'borderInactive'}>
                                     {language[item]}
                                </li>
                        })}
                        </ul>
                    </div>
                    <div className='dropdown'>
                        <Dropdown 
                         textCenter
                         style={{ height: '30px', width: '100%', textAlign: 'left' }}
                         selectedOptions={[dropdownData[0]]}
                         options={dropdownData}
                         innerRef={e => this.goodTillDateRef = e}
                         onChange={this.handleDropdown}
                         />
                    </div>
                </div>
                {/* blockSelect */}
                <div className='block_select'>
                    <ul>
                        {mapData.map((item,index)=>{
                            return (<li key={item}>
                                        <div onClick={() => this.hanldeBlockSelect(item,index)} 
                                             onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.hanldeBlockSelect(item,index))}
                                             {...accessibilityFunctions.hasTabIndex()}
                                            className={block_select_index === index ? 'blockActive' : 'inactive'}> {language[item]}
                                        </div>
                                    </li>)
                        })}
                    </ul>
                </div>
                {/* RANK */}
                <div className='rank'>
                    { rankName && rankName.map((item,index)=>{
                        return (
                            <div className={item.className} key={item.className}>
                                <div style={{opacity: (rating == index && iconRank) ? 1 : 0}}> 
                                    <div className='num'>
                                    {language.market_rank}
                                    <span style={{color:item.color}}>{language.market_no}{iconRank}</span>
                                    </div>
                                <div className='icon'><img src={item.icon}></img> </div> 
                            </div>
                                <div className='line'></div>
                                <div className='text'>{language[item.className]}</div>
                            </div>
                        )
                    })}
                  
                </div>
                {/* RANKING */}
                <div className='ranking'>
                    <h4>{ PercentageFlag ?  language.market_ranking_unit_percentage :  language.market_ranking_unit_hkd}</h4>
                        { rankData &&  
                            (rankData.map((item,index)=> {
                           return  ( <div className='box' key={item}>
                                <div className='rank_title'>
                                    <span className={iconRank == (index + 1) ? 'current_stock' : ''}>{index + 1} </span>
                                    </div>
                                <div className='center'>
                                    { resName &&  this.handleRowName(item,index)}
                                    <div 
                                    className='ranking_line'
                                    style={{width:item[2].indexOf('-') != -1 ? '0%' : item[2]/rankDataMax*100 < 5 ? '5%'  : (item[2] / rankDataMax * 100 + '%')}}>
                                    </div>
                                </div>
                                <div className='rank_data'>{item[2].includes('.') ? item[2].split('.')[0] + '.' + item[2].split('.')[1].substr(0,4) : item[2] }</div>
                            </div>)
                        }) 
                        )}
                        { !rankData &&
                                (<div style={{width:'100%' , height:'200px'}}>
                                    <h2 style={{textAlign:'center',lineHeight:'200px'}}>{language.common_no_data}</h2>
                                </div>)}
                </div>
            </div>
            </div>
            
        )
    }
    componentDidMount(){
        this.props.innerRef(this)
        const { marketParams } = this.props;
        const { marketID, stockCode } = marketParams;
        this.setState({
            marketID: marketID,
            InstrumentID: stockCode
        },()=>{
            this.change()
        })
    }
    componentDidUpdate(preProps) {
        const { currentTradingAccount, isNeedRefresh, language, mdsToken ,marketParams} = this.props
        const { marketID, stockCode } = marketParams;
        
        if (language && preProps.language !== language) {
            this.change()
        }
        if(marketParams && preProps.marketParams !== marketParams){
            this.setState({ 
            marketID: marketID,
            InstrumentID: stockCode,
            rankData:null,
            ul_check_index:0,
            block_select_index:0,
            currentDropdownOption:null,
            PercentageFlag:false
        },()=>{
                this.change()
            })
        }
        if(preProps.mdsToken != mdsToken && mdsToken){
            this.change()
        }  
    }

    iconRank= () =>{
        let stockID = this.state.InstrumentID
        stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        let iconRank = ''
        let rating = ''
        if(this.state.rankData){
            this.state.rankData.filter((item,index)=>{
            if(item[1] == stockID){
                iconRank = index + 1
            } 
        })
        if( parseInt(iconRank / (this.state.rankData.length/ 5 )) > 4)   { rating = 4 }
        else {rating =  parseInt(iconRank / (this.state.rankData.length/ 5 ))}
        }
        this.setState({iconRank,rating})
    }
    
    handleRowName = (item,index) =>{
        const {language} = this.props
        let name =  this.state.resName?.data.filter((nameItem)=>{
            return nameItem[1] == item[1]
        })
        if(name.length != 0){
            switch(language.key){
                        case 'CN':
                            return <div className={this.state.iconRank == (index + 1) ? 'ranking-name-active' : 'ranking-name'} >{name[0][4]}</div>
                        case 'EN':
                            return <div className={this.state.iconRank == (index + 1) ? 'ranking-name-active' : 'ranking-name'} >{name[0][2]}</div>
                        case 'HK':
                            return <div className={this.state.iconRank == (index + 1) ? 'ranking-name-active' : 'ranking-name'} >{name[0][3]}</div>
                    } 
        }
           
    }
    handleDropdown = (data) => {
           this.setState({currentDropdownOption:data[0].value},()=>{
            this.change()
        }) 
    }

    hanldeHeaderList = (item,index) =>{
        const {main_select_data,profit_select_data,growth_select_data} = this.state
        if(this.state.ul_check_index != index ){
                  this.setState({ul_check_index:index ,block_select_index:0},()=>{
            this.change()
        })  
        switch(index){
            case 0 :
               this.setState({mapData:main_select_data,PercentageFlag:false})
               break;
            case 1 :
                this.setState({mapData:profit_select_data,PercentageFlag:true})
                break;
            case 2 :
                this.setState({mapData:growth_select_data,PercentageFlag:true})
                break;
       }
    }
        
    }
    hanldeBlockSelect = (item, index) => {
        if(this.state.block_select_index != index){
             this.setState({ block_select_index: index }, () => {
           this.change()
        }) 
        }
       
    }

     change = async() =>{
        this.getDropdownData()
        const { ul_check_index, currentDropdownOption ,resReport} = this.state
        const currentYear = currentDropdownOption?.split(' ')[0]
        const currentType = currentDropdownOption?.split(' ')[1]
        const currentData =  resReport.filter((item) => {
            return item.year == currentYear && item.type == currentType
        })
        switch(ul_check_index){
            case 0:
                switch(this.state.block_select_index){
                    case 0:
                        this.setState({  rankData: currentData[0]?.PerIncome?.data })
                        break;
                    case 1:
                        this.setState({ rankData: currentData[0]?.PerAsset.data })
                        break;
                    case 2:
                        this.setState({ rankData: currentData[0]?.PriceEarnRatio?.data})
                        break;
                    case 3:
                        this.setState({rankData: currentData[0]?.PriceBookRatio?.data })
                        break;
                }
                break
            case 1:
                switch (this.state.block_select_index) {
                    case 0:
                        this.setState({ rankData: currentData[0]?.GrossProfitRatio?.data })
                        break;
                    case 1:
                        this.setState({ rankData: currentData[0]?.NetProfitRatio?.data })
                        break;
                    case 2:
                        this.setState({ rankData: currentData[0]?.ReturnOnEquity?.data })
                        break;
                    case 3:
                        this.setState({ rankData: currentData[0]?.ReturnOnAssets?.data })
                        break
                }
                break;
            case 2:
                switch (this.state.block_select_index) {
                    case 0:
                        this.setState({ rankData: currentData[0]?.IncomeGrowRate?.data })
                        break;
                    case 1:
                        this.setState({ rankData: currentData[0]?.ProfitGrowRate?.data })
                        break;
                    case 2:
                        this.setState({ rankData: currentData[0]?.AssetsGrowRate?.data })
                        break;
                }
                break
        }
    }
    rankDatalongest = () =>{
        if(this.state.rankData){
             let rankDataMax = this.state.rankData[0][2]
                for (let i = 0 ; i < this.state.rankData.length - 1 ; i++)
                    rankDataMax = Number(rankDataMax)  < Number(this.state.rankData[i+1][2])  ? Number(this.state.rankData[i+1][2]) : Number(rankDataMax)
                    this.setState({rankDataMax})
        } 
    }

    getDropdownData = () =>{
        this.setState({load:true , rankDataMax:1000000})
        let { marketID, InstrumentID } = this.state
        const {language} = this.props
        marketID = Converter.mappingWebSocketMarket(marketID);
        let stockID = InstrumentID
        stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        const params = {
            msgType: ACTION_TYPE.DETAIL_INDUSTRY_RANK,
            symbols: [{ exchangeID: Converter.mappingWebSocketMarket(marketID), key: stockID }],
        }
        this.props.getMainIndicator(params,res => {
            if(res){
                let value = ''
                let label = ''
                let dropdownData = []

                for(let i = 0;i<res.report.length ; i ++ ){
                    let Q = ''
                    if(res.report[i].type == 'Final') Q = 'Q4'
                    if(res.report[i].type == 'Interim') Q = 'Q2'
                    label  = res.report[i].year + ' ' + Q + ' ' + language.market_report + '  '
                    value = res.report[i].year + ' ' + res.report[i].type + ' '
                    dropdownData.push({value:value,label:label})
                }

                if(!this.state.rankData && this.state.ul_check_index == 0 && this.state.block_select_index == 0 )
                {this.setState({rankData:res.report[0]?.PerIncome?.data,})}

                if(!this.state.currentDropdownOption) 
                this.setState({currentDropdownOption:dropdownData[0].value,})

                this.setState({
                    dropdownData:dropdownData,
                    resName:res.name,
                    resReport:res.report,
                    load:false
                    },()=>{
                        this.iconRank()
                        this.rankDatalongest()
                    })
            } 
        })
    }
}


export default connect(
    state =>({
        language: state.app.language,
        marketParams: state.trade.marketParams,
    }),
    dispatch => ({
        getMainIndicator:(p,c) => stockActions.getDetailIndustryRankAction(p,c)
    })
)(Index)